<template>
  <div id="order-delivery-package" v-loading="loading">
    <form class="row search-pannel" :class="{ fold: fold }" @submit.prevent="doQuery">
      <input type="submit" style="display:none" />
      <div class="col-sm-3">
        <el-input size="small" v-model="query.orderSn" placeholder="订单编号" clearable />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.keyword" placeholder="买家名称/手机号/收货人手机号" clearable />
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.startTime" value-format="yyyy-MM-dd" placeholder="出库时间-开始" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.endTime" value-format="yyyy-MM-dd" placeholder="出库时间-结束" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.payType" placeholder="支付方式">
          <el-option label="全部" :value="0" />
          <el-option label="挂账" :value="1" />
          <el-option label="现款" :value="2" />
        </el-select>
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.orderType" placeholder="订单类型">
          <el-option label="全部" :value="0" />
          <el-option label="批单" :value="1" />
          <el-option label="急件" :value="2" />
        </el-select>
      </div>
      <div class="folder">
        <el-button type="primary" size="small" @click="doQuery">查询</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">
          {{ fold ? '展开' : '收起' }}
          <i v-if="fold" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" />
        </el-button>
      </div>
    </form>
    <div class="data-header">
      <div class="row" :style="{ paddingRight: hasScroll ? scrollBarWidth + 'px' : 'px' }">
        <div class="col-sm-1">#</div>
        <div class="col-sm-3">订单编号</div>
        <div class="col-sm-3">出库时间</div>
        <div class="col-sm-5">买家信息</div>
        <div class="col-sm-5">收货信息</div>
        <div class="col-sm-1">门店</div>
        <div class="col-sm-3">包裹统计</div>
        <div class="col-sm-1">图片</div>
        <div class="col-sm-2">操作</div>
      </div>
    </div>
    <div ref="dataList" class="data-list">
      <template v-if="list && list.length">
        <div v-for="item in list" :key="item.id" class="order-delivery-wraper">
          <div class="order-delivery-item row">
            <div class="col-sm-1">
              <el-checkbox v-model="item.checked" />
            </div>
            <div class="col-sm-3">
              <label class="cont-label">订单编号</label>
              <div>{{ item.orderSn }}</div>
            </div>
            <div class="col-sm-3">
              <label class="cont-label">出库时间</label>
              <div>{{ item.createTime | dateTimeFmt }}</div>
            </div>
            <div class="col-sm-5">
              <label class="cont-label">买家信息</label>
              <div>
                <ellipsis-text :content="`${item.buyerCompanyName}/${item.buyerName}/${item.buyerPhone }`">
                  {{ item.buyerCompanyName }}/{{ item.buyerName }}/{{ phoneShow(item.buyerPhone) }}
                </ellipsis-text>
              </div>
            </div>
            <div class="col-sm-5">
              <label class="cont-label">收货信息</label>
              <div>
                <ellipsis-text :content="`${item.nameAddressee}/${item.phoneAddressee}/${item.addressAddressee}`">
                  {{ item.nameAddressee }}/{{ item.phoneAddressee }}/{{ item.addressAddressee }}
                </ellipsis-text>
              </div>
            </div>
            <div class="col-sm-1">
              <label class="cont-label">门店</label>
              <div>
                <ellipsis-text :content="item.shopName">
                  {{ item.shopName }}
                </ellipsis-text>
              </div>
            </div>
            <div class="col-sm-3">
              <label class="cont-label">包裹统计</label>
              <div>
                <ellipsis-text :content="`${ item.partCategory }条 ${ item.partCount }件 ¥${ item.totalAmount }`">
                  {{ item.partCategory }}条{{ item.partCount }}件&yen;{{ item.totalAmount | currencyFmt }}
                </ellipsis-text>
              </div>
            </div>
            <div class="col-sm-1">
              <label class="cont-label">发货图片</label>
              <div>
                <el-image v-if="item.image" :src="item.image" :preview-src-list="item.imageList"></el-image>
              </div>
            </div>
            <div class="col-sm-2">
              <el-button type="text" size="mini" @click="showDetail(item)">明细</el-button>
              <el-button type="text" size="mini" @click="doExp([item.id])">导出</el-button>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="no-data">
        暂无数据~
      </div>
    </div>
    <div class="page-footer">
      <div>
        <el-button v-if="selectedIds && selectedIds.length" type="primary" size="small" @click="multipleExp">导出</el-button>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size.sync="pagination.pageSize"
        @current-change="doLoadData"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { ListPackageOrder, ExportPakcageOrder } from './services'
import { bind, unbind } from '@/utils/eventBinder.js'
import _ from 'lodash'
export default {
  name: 'OrderAppy',
  data () {
    return {
      fold: true,
      loading: false,
      query: {
        orderSn: undefined,
        keyword: undefined,
        startTime: undefined,
        endTime: undefined,
        orderType: 0,
        payType: 0
      },
      list: [],
      hasScroll: false,
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0
      }
    }
  },
  computed: {
    auth () {
      return this.$store.state.auth || {}
    },
    isSaler () {
      return this.auth.id !== 1
    },
    renderRow () {
      return this.list.length
    },
    scrollBarWidth () {
      return this.$store.state.scrollbarWidth
    },
    selectedIds () {
      return this.list.filter(t => t.checked).map(t => t.id)
    }
  },
  watch: {
    renderRow () {
      this.$nextTick(() => {
        this.checkScrollbar()
      })
    }
  },
  mounted () {
    this.checkScrollBarDebounce = _.debounce(() => {
      this.checkScrollbar()
    }, 50)
    bind(window, 'resize', this.checkScrollBarDebounce)
    this.doLoadData()
  },
  beforeDestory () {
    unbind(window, 'resize', this.checkScrollBarDebounce)
  },
  methods: {
    showDetail (item) {
      this.modal('OrderPackageDetailModal', item.id)
    },
    multipleExp () {
      this.doExp(this.selectedIds)
    },
    doExp (ids) {
      ExportPakcageOrder(ids).then(() => {
        this.$message.success('已导出')
      }).catch((err) => {
        console.log(err)
        this.$message.error('导出失败')
      })
    },
    doQuery () {
      this.pagination.pageIndex = 1
      this.doLoadData()
    },
    doLoadData () {
      if (this.loading) return
      this.loading = true
      const { pageIndex, pageSize } = this.pagination
      const { orderSn, keyword, startTime, endTime, orderType, payType } = this.query
      ListPackageOrder({
        orderSn,
        keyword,
        startTime,
        endTime,
        pageIndex,
        pageSize,
        orderType,
        payType
      }).then((resp) => {
        const { pageIndex, pageSize, totalCount, items } = resp
        items.forEach(item => {
          item.checked = false
          const imageList = (item.deliveryImages || '').split(',').filter(t => t)
          item.image = imageList[0]
          item.imageList = imageList
        })
        this.list = items
        this.pagination.pageIndex = pageIndex
        this.pagination.pageSize = pageSize
        this.pagination.totalCount = totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    checkScrollbar () {
      const dataList = this.$refs.dataList
      if (dataList) {
        this.hasScroll = dataList.clientHeight < dataList.scrollHeight
      } else {
        this.hasScroll = false
      }
    }
  }
}
</script>
